Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.withForwardRef = void 0;

var _react = _interopRequireDefault(require('react'));

var _hoistNonReactStatics = _interopRequireDefault(require('hoist-non-react-statics'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends(target) {
  if (Object.assign) {
    return Object.assign.apply(Object, arguments);
  }

  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
}

var withForwardRef = function withForwardRef(WrappedComponent) {
  var ForwardRefComponent = _react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(
      WrappedComponent,
      _extends(
        {
          forwardedRef: ref
        },
        props
      )
    );
  });

  ForwardRefComponent.defaultProps = WrappedComponent.defaultProps;
  (0, _hoistNonReactStatics.default)(ForwardRefComponent, WrappedComponent);
  return ForwardRefComponent;
};

exports.withForwardRef = withForwardRef;
